import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/newsletter/page.tsx");
